// This file is generated by icon spritesheet generator

export const iconNames = [
	'update',
	'trash',
	'sun',
	'reset',
	'question-mark-circled',
	'plus',
	'pencil-2',
	'pencil-1',
	'moon',
	'magnifying-glass',
	'lock-open-1',
	'lock-closed',
	'link-2',
	'laptop',
	'github-logo',
	'file-text',
	'exit',
	'envelope-closed',
	'download',
	'dots-horizontal',
	'cross-1',
	'clock',
	'check',
	'camera',
	'avatar',
	'arrow-right',
	'arrow-left',
] as const

export type IconName = (typeof iconNames)[number]
